module.exports = __webpack_public_path__ + "static/media/nestle-health-science-logo@2x.89e9cbfa.png";